import tw from "twin.macro"

import { StyledRule } from "../../../Styled/Rule"
import { StyledRow } from "../../../Styled/Row"
import { P, H5 } from "../../../Styled/Text"

export const Section = tw.section`bg-teal-mint border border-teal rounded-xl pt-8 pb-5 px-5 md:pt-12 md:px-7.5 md:pb-4 md:px-13.75 md:pt-14 md:pb-10.25 my-10 md:my-16`
export const Title = tw(P)`md:text-lg font-bold`
export const Rule = tw(StyledRule)`my-4 md:my-8`
export const Content = tw(P)`max-w-full md:w-2/3`
export const Cost = tw(H5)`mr-1.5`
export const Pricing = tw(StyledRow)`mb-8 md:mb-10`
